var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTickets = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 176.25 146.25"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Tickets_svg__cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:11.25px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Tickets_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tickets_svg___\\xCE\\xD3\\xC8_1",
  "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "Tickets_svg__cls-1",
  d: "m170.63 20.63-82.5 60-82.5-60"
}), /*#__PURE__*/React.createElement("path", {
  className: "Tickets_svg__cls-1",
  d: "M5.63 5.63h165v135h-165z"
})))));
export default SvgTickets;